import $ from 'jquery'

$.fn.ajaxList = function() {

	return this.each( function() {

		const $list    = $( this );
		const $groups  = $list.find( '.wwp3-sponsor-list--separator' );
		const groupBy  = $list.data( 'group-by' );
		let items      = [];
		let $loading   = null;
		const groupBys = {
			wwp3_branch: 'branch',
			wwp3_team:   'team'
		};

		$groups.click( function() {

			const $group   = $( this );
			const isActive = $group.hasClass( 'active' );

			while ( items.length ) {

				items.pop().remove();

			}

			$list.find( '> .active' ).removeClass( 'active' );

			if ( isActive ) {

				return;

			}

			$group.addClass( 'active' );

			$loading && $loading.remove();

			const groupName = $group.find( '.wwp3-sponsor-list-meta__label' ).text().replace( /\u00AD/g, '' );
			let flex        = $group.css( 'flex' );

			if ( ! flex && $group.length ) {

				flex = $group[ 0 ].style.flex;

			}

			$loading = $( '<li/>' ).addClass( 'wwp3-sponsor-list wwp3-column' ).css( 'flex', flex ).insertAfter( $group ).append(
				'<div class="js-wwp3-loading wwp3-loading sk-fading-circle">' +
				'  <div class="sk-circle1 sk-circle"></div>' +
				'  <div class="sk-circle2 sk-circle"></div>' +
				'  <div class="sk-circle3 sk-circle"></div>' +
				'  <div class="sk-circle4 sk-circle"></div>' +
				'  <div class="sk-circle5 sk-circle"></div>' +
				'  <div class="sk-circle6 sk-circle"></div>' +
				'  <div class="sk-circle7 sk-circle"></div>' +
				'  <div class="sk-circle8 sk-circle"></div>' +
				'  <div class="sk-circle9 sk-circle"></div>' +
				'  <div class="sk-circle10 sk-circle"></div>' +
				'  <div class="sk-circle11 sk-circle"></div>' +
				'  <div class="sk-circle12 sk-circle"></div>' +
				'</div>'
			);

			let filter = {
				limit: 10000,
				type: [ 'wwp3_sponsor' ]
			};

			filter[ groupBys[ groupBy ] ] = [ groupName ];

			$.ajax( {
				data: {
					action: 'wwp3_search',
					ajaxcall: true,
					filter: JSON.stringify( filter )
				},
				success: function( e ) {

					if ( e.result.length ) {

						$loading.remove();

						for ( let i = e.result.length - 1; i >= 0; i-- ) {

							const item   = e.result[ i ];
							const $item  = $( '<li/>' ).addClass( 'wwp3-sponsor-list wwp3-column' ).css( 'flex', flex ).insertAfter( $group );
							const $a     = $( '<a/>' ).addClass( 'wwp3-sponsor-list__inner' ).appendTo( $item ).attr( 'href', item.permalink );
							const $image = $( '<div/>' ).addClass( 'wwp3-sponsor-list__logo' ).appendTo( $a );
							const $info  = $( '<div/>' ).addClass( 'wwp3-sponsor-list__info' ).appendTo( $a );

							item.image && $( '<img src="' + item.image + '" alt=""/>' ).appendTo( $image );

							$( '<div/>' ).addClass( 'wwp3-sponsor-list__label' ).appendTo( $info ).append( item.title );

							items.push( $item );

						}

					} else {

						$loading.html( 'Keine Sponsoren gefunden.' ); // TODO translate HTML

					}

				},
				type: 'post',
				url: window.wwp3[ 'ajaxurl' ]
			} );

		} );

	} );

};

const AjaxLists = () => {

	const init = () => {

		$( '.wwp3-ajax-list' ).ajaxList();

	};

	init();

};

export default AjaxLists



// WEBPACK FOOTER //
// src/assets/js/front-end/components/ajax-lists.js